import convert from "../assets/convert.png";
import { Heading1Component } from "./Tags/heading";
import { ParagraphComponent } from "./Tags/paragraph";
import SubLayout from "../common/subLayout";
import { ButtonComponent } from "./Tags/button";

const Convert = (): JSX.Element => {
  const handleSellWaste = () => {
    window.open('https://wa.me/2348038551338?text=Hello%20GJC%20Recycling%2C%20I%20want%20to%20sell%20my%20plastic%20waste', '_blank');
  };

  return (
    <SubLayout
      _style2="md:flex items-center justify-between gap-12 py-12"
      _style="max-w-6xl mx-auto px-4"
    >
      <div className="max-w-lg space-y-6">
        {/* Small label */}
        <span className="text-green-600 font-semibold text-sm uppercase tracking-wider">
          ♻️ Earn from Waste
        </span>

        <Heading1Component 
          text="Turn Your Waste into Cash" 
          _style="text-4xl md:text-5xl font-bold text-gray-900 leading-tight"
        />
        
        <ParagraphComponent
          text="We empower communities to capture value from their waste. Sell your recyclable materials to us and get paid instantly while helping build a cleaner environment."
          _style="text-gray-600 text-lg leading-relaxed"
        />
        
        <div className="flex flex-wrap gap-4 pt-2">
          <ButtonComponent
            clickHandler={handleSellWaste}
            _style="px-8 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            title="Sell Your Waste Now"
            type="dark"
          />
        </div>

        {/* Simple trust indicators */}
        <div className="flex items-center gap-6 pt-4 text-sm text-gray-500">
          <span className="flex items-center gap-1"> Instant Payment</span>
          <span className="flex items-center gap-1"> Free Pickup</span>
          <span className="flex items-center gap-1"> Eco-Friendly</span>
        </div>
      </div>

      <div className="mt-8 md:mt-0">
        <img 
          src={convert} 
          alt="Convert waste to money" 
          className="w-full max-w-md rounded-2xl shadow-xl"
        />
      </div>
    </SubLayout>
  );
};

export default Convert;